import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { to: '/about-us', label: 'About Us', icon: 'ℹ️' },
    { to: '/contact-us', label: 'Contact Us', icon: '📧' },
    { to: '/terms-conditions', label: 'Terms & Conditions', icon: '📜' },
    { to: '/privacy-policy', label: 'Privacy Policy', icon: '🔒' }
  ];

  const socialLinks = [
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@Spardhaweb',
      icon: 'fab fa-youtube',
      color: '#FF0000'
    },
    {
      name: 'Telegram',
      url: 'https://t.me/+BdSatS5bmdE5ODQ1',
      icon: 'fab fa-telegram',
      color: '#0088cc'
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/mpsc_insta?igsh=MWtobmFudjk1OGxndA==',
      icon: 'fab fa-instagram',
      color: '#E4405F'
    },
    {
      name: 'WhatsApp',
      url: 'https://whatsapp.com/channel/0029VacaEMFInlqSAA9ilQ1f',
      icon: 'fab fa-whatsapp',
      color: '#25D366'
    }
  ];

  return (
    <footer className="modern-footer">
      <div className="footer-content">
        <div className="container">
          {/* Top Section */}
          <div className="footer-top">
            <div className="row g-4">
              {/* Brand Section */}
              <div className="col-lg-4 col-md-12">
                <div className="footer-brand">
                  <h3 className="brand-name">
                    <span className="brand-icon">📚</span>
                    Spardhaweb
                  </h3>
                  <p className="brand-tagline">
                    Your trusted partner for MPSC exam preparation. 
                    Access quality study materials, test series, and daily current affairs.
                  </p>
                  <div className="brand-stats">
                    <div className="stat-item">
                      <span className="stat-number">1000+</span>
                      <span className="stat-label">Students</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-number">500+</span>
                      <span className="stat-label">Tests</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-number">100+</span>
                      <span className="stat-label">Materials</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Links */}
              <div className="col-lg-4 col-md-6">
                <div className="footer-section">
                  <h4 className="footer-title">Quick Links</h4>
                  <ul className="footer-links">
                    {footerLinks.map((link) => (
                      <li key={link.to}>
                        <Link to={link.to} className="footer-link">
                          <span className="link-icon">{link.icon}</span>
                          <span className="link-text">{link.label}</span>
                          <span className="link-arrow">→</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Connect Section */}
              <div className="col-lg-4 col-md-6">
                <div className="footer-section">
                  <h4 className="footer-title">Connect With Us</h4>
                  <p className="connect-text">
                    Follow us on social media for daily updates, tips, and study materials.
                  </p>
                  <div className="social-links">
                    {socialLinks.map((social) => (
                      <a
                        key={social.name}
                        href={social.url}
                        className="social-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={social.name}
                        style={{ '--social-color': social.color }}
                      >
                        <i className={social.icon}></i>
                      </a>
                    ))}
                  </div>
                  <div className="newsletter-section">
                    <p className="newsletter-text">Stay updated with our latest content</p>
                    <div className="newsletter-badge">
                      <span className="badge-icon">🔔</span>
                      <span className="badge-text">Join our community</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="footer-bottom">
            <div className="footer-divider"></div>
            <div className="footer-bottom-content">
              <p className="copyright">
                © {currentYear} <span className="brand-highlight">spardhaweb.com</span> | All rights reserved
              </p>
              <p className="made-with">
                Made with <span className="heart">❤️</span> for MPSC Aspirants
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="footer-decoration">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
      </div>
    </footer>
  );
};

export default Footer;